import { Card, Skeleton, SkeletonAvatar, SkeletonRegion } from '@parsina/framework';
import { RADIUS } from '@parsina/framework/tokens';
import { useTranslation } from '@parsina/framework/clinical/src/i18n/index';

// ─────────────────────────────────────────────────────────────────────────────
// The patient lookup's result list while a search is in flight. The
// MobileHeader and the search field stay real (the doctor keeps typing); each
// placeholder is one `MobilePatientResultCard` — a Card whose tappable body is
// `p-3` with a 40px avatar, the name + identity lines and the trailing chevron.
// ─────────────────────────────────────────────────────────────────────────────

const ResultCardSkeleton = ({ i }) => (
  <Card aria-hidden style={{ padding: 0, overflow: 'hidden' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem', padding: '0.75rem', minHeight: 44 }}>
      <SkeletonAvatar size={40} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
        <Skeleton width={`${46 + ((i * 17) % 30)}%`} height={14} />
        <Skeleton width={`${30 + ((i * 11) % 24)}%`} height={11} />
      </div>
      <Skeleton width={16} height={16} radius={RADIUS.chip} />
    </div>
  </Card>
);

export const PatientLookupListSkeleton = ({ count = 3, label }) => {
  const { t } = useTranslation();
  return (
    <SkeletonRegion label={label ?? t('common.state.loading')} data-testid="lookup-loading" style={{ display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
      {Array.from({ length: count }, (_, i) => <ResultCardSkeleton key={i} i={i} />)}
    </SkeletonRegion>
  );
};

export default PatientLookupListSkeleton;
